import PatientService from "../../Services/PatientService";

export const FETCH_PROCEDURES_REQUEST = "FETCH_PROCEDURES_REQUEST";
export const FETCH_PROCEDURES_SUCCESS = "FETCH_PROCEDURES_SUCCESS";
export const FETCH_PROCEDURES_FAILURE = "FETCH_PROCEDURES_FAILURE";

export const FETCH_PROCEDURES_COUNT_REQUEST = "FETCH_PROCEDURES_COUNT_REQUEST";
export const FETCH_PROCEDURES_COUNT_SUCCESS = "FETCH_PROCEDURES_COUNT_SUCCESS";
export const FETCH_PROCEDURES_COUNT_FAILURE = "FETCH_PROCEDURES_COUNT_FAILURE";

export const PROCEDURES_FILTER_ENABLED="PROCEDURES_FILTER_ENABLED";
export const PROCEDURES_FILTER_CLEAR="PROCEDURES_FILTER_CLEAR";

export const fetchProcedures = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_PROCEDURES_REQUEST });
    try {
        const response = await PatientService.procedureReqList(payload);
        dispatch({ type: FETCH_PROCEDURES_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_PROCEDURES_FAILURE, payload: error.message });
    }
}

export const fetchProceduresCount = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_PROCEDURES_COUNT_REQUEST });
    try {
        const response = await PatientService.procedureReqListCount(payload);
        dispatch({ type: FETCH_PROCEDURES_COUNT_SUCCESS, payload: response.data.TOTAL_COUNT_STATUS });
    }
    catch (error) {
        dispatch({ type: FETCH_PROCEDURES_COUNT_FAILURE, payload: error.message });
    }
}

export const setProceduresFilter = (state) => ({
  type: PROCEDURES_FILTER_ENABLED,
  payload: state,
});

export const clearProceduresFilter = (state) => ({
  type: PROCEDURES_FILTER_CLEAR,
  payload: state,
});